export default __webpack_public_path__ + "static/media/l11.9de47ba8.jpg";